import React from 'react'
import {toast, ToastContainer} from 'react-toastify';

const Logout = () => {
  return (
    <main id="main" className="main">
            <div className="pagetitle">
                <h1>Logout</h1>
            </div>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row">

                        </div>
                    </div>
                </div>
            </section>

        </main>

  )
}

export default Logout